import Login from 'pages/Login';

const prefix = '/login';

const routes = [
  {
    path: `${prefix}`,
    component: Login,
    exact: true,
  },
];

export default routes;
